import {
  UPDATE_SHOW_SWAP_NOTIFICATION,
  UPDATE_SHOW_SWAP_MODAL_STATUS
} from './action-constants';

export const updateShowModalStatus = (status, parentDesignId, newDesignId, cameraId) => ({
  type: UPDATE_SHOW_SWAP_MODAL_STATUS,
  payload: { status, parentDesignId, newDesignId, cameraId }
});

export const updateShowSwapNotification = ({
  cameraId,
  design,
  messageType,
  productIds,
  renderUid,
  status
}) => ({
  type: UPDATE_SHOW_SWAP_NOTIFICATION,
  payload: {
    cameraId,
    design,
    messageType,
    productIds,
    renderUid,
    status
  }
});

export const hideSwapInfo = () => dispatch => {
  // hide swap modal
  dispatch(updateShowModalStatus(false, null, null, null));
  dispatch(updateShowSwapNotification(false));
};
